import type { SignInCodeChannel } from '@chukua/common';
import { useEffect, useState } from 'react';
import { getSignInCodeChannels } from '../../../shared/features/session/session.api';

/**
 * The channels a sign-in code can go by, asked once. Null until the server answers, so the page shows its skeleton
 * rather than one step and then another; a failed request reads as none, since a code couldn't be sent either.
 */
export function useSignInCodeChannels(): SignInCodeChannel[] | null {
  const [channels, setChannels] = useState<SignInCodeChannel[] | null>(null);

  useEffect(() => {
    let isCurrent = true;
    getSignInCodeChannels()
      .then((answer) => isCurrent && setChannels(answer.channels))
      .catch(() => isCurrent && setChannels([]));
    return () => {
      isCurrent = false;
    };
  }, []);

  return channels;
}
